import { SAGA_ACTIONS } from "../../constants";
import { useApiCall } from "../common/appApiCallHook";



export function useBudgetApi() {

    const callApi = useApiCall();

    const fetchBudget = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BUDGET.FETCH_DETAILS, data, onSuccess, onError);
    }

    const postBudget = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BUDGET.ADD, data, onSuccess, onError);
    }

    const updateBudget = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BUDGET.UPDATE, data, onSuccess, onError);
    }

    const publishBudget = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BUDGET.PUBLISH, data, onSuccess, onError);
    }

    const downloadBudgetReport = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BUDGET.DOWNLOAD_REPORT, data, onSuccess, onError);
    }

    const downloadBudgetReportExcel = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BUDGET.DOWNLOAD_REPORT_EXCEL, data, onSuccess, onError);
    }

    return {
        fetchBudget,
        postBudget,
        updateBudget,
        publishBudget,
        downloadBudgetReport,
        downloadBudgetReportExcel,
    }
}